<script lang="ts">
	export let fill = "#bcbfc3";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 18.123 19.337">
	<g>
		<g>
			<path
				d="M482.788 215.545a7.909 7.909 0 1 0-2.676 9.437 6.6 6.6 0 0 0 .611-.49c.121-.1.233-.21.346-.323a7.859 7.859 0 0 0 2.315-5.594 7.969 7.969 0 0 0-.596-3.03zm-2.272 8.072a7.15 7.15 0 0 1-.724.63 7.131 7.131 0 1 1 2.813-5.672 7.067 7.067 0 0 1-2.089 5.042z"
				transform="translate(-467.562 -210.667)"
				style={`fill:${fill}`} />
		</g>
		<g>
			<path
				d="M504.42 251.036a.389.389 0 0 1-.275-.114l-5.169-5.169a.389.389 0 1 1 .55-.55l5.17 5.169a.389.389 0 0 1-.275.664z"
				transform="translate(-486.686 -231.699)"
				style={`fill:${fill}`} />
		</g>
	</g>
</svg>

<style lang="scss">
	path {
		transition: fill 0.5s;
		fill: #bcbfc3;
	}

</style>
